export default {
  path: '/date-user-rule',
  component: () => import('./DateUserAgreement'),
  meta: {
    title: '青藤Date用户协议',
    designWidth:750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}
